import {environment} from "../../environments/environment";

export const buildUrl = (...parts: Array<string | number>): string => `${environment.apiUrl}/${parts.join('/')}`;
